export const MAX_SERVICE_DESCRIPTION = 140;
